import React, { useState, useRef, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import useCloseOnOutsideClick from 'utils/hooks/useCloseOnOutsideClick';
import ConstituentAvatar from 'components/ConstituentAvatar';
import oIconLibrary from 'utils/iconLibrary';
import { Link } from 'react-router-dom';
import Button from 'components/Buttons/Button';
import { currentUserFirstLastNameSelector } from 'redux/selectors';
import {
  selectCurrentUserAddress,
  selectCurrentUserPrimaryEmployer,
} from 'components/MyProfile/redux/selectors';
import { fnSignOut } from 'components/NavBar/helpers';
import Notifications from './Notifications';

const UserProfileMenu = () => {
  const aNotificationsData = useSelector(
    (state) => state.Profile?.NOTIFICATIONS || []
  );
  const { LOOKUPID, NICKNAME, LASTNAME, HAS_PHOTO } = useSelector(
    (state) => state.Profile.BIOGRAPHICAL || {}
  );
  const { sName = '' } = useSelector(currentUserFirstLastNameSelector);
  const address = useSelector(selectCurrentUserAddress);
  const employer = useSelector(selectCurrentUserPrimaryEmployer);

  const [bHasUnreadNotifications, fnSetHasUnreadNotifications] =
    useState(false);
  const [bShowModal, fnSetShowModal] = useState(false);
  const notificationsRef = useRef();

  useEffect(() => {
    const bHasUnread = aNotificationsData.some(
      (item) => item.READSTATUS === false
    );
    fnSetHasUnreadNotifications(bHasUnread);
  }, [aNotificationsData]);

  const handleClick = () => {
    fnSetShowModal(!bShowModal);
  };

  useCloseOnOutsideClick(notificationsRef, fnSetShowModal, bShowModal);

  return (
    <div className='userProfileMenu__wrapper' ref={notificationsRef}>
      <button
        type='button'
        aria-label={`${bShowModal ? 'Hide' : 'Show'} notifications`}
        onClick={handleClick}
        className='userProfileMenu__toggle'
      >
        <div
          className={`userProfileMenu__avatar${
            bHasUnreadNotifications ? '--unread' : ''
          }`}
        >
          <ConstituentAvatar
            lookupId={LOOKUPID}
            sFirstName={NICKNAME}
            sLastName={LASTNAME}
            bHasPhoto={HAS_PHOTO}
            sSize='small'
          />
        </div>
        <FontAwesomeIcon
          icon={oIconLibrary.fontAwesome[bShowModal ? 'collapse' : 'expand']}
          className='userProfileMenu__chevron'
        />
      </button>
      {bShowModal && (
        <div className='userProfileMenu__modal' role='dialog'>
          <div className='userProfileMenu__modalHeader'>
            <p className='userProfileMenu__name t-paragraph--medium'>{sName}</p>
            {address && (
              <p className='userProfileMenu__location t-paragraph--small'>
                {address.city}, {address.state}
              </p>
            )}
            {employer && (
              <p className='userProfileMenu__employer t-paragraph--small'>
                {employer}
              </p>
            )}
          </div>
          <Notifications fnSetShowModal={fnSetShowModal} />
          <Link to='/profile-settings' className='userProfileMenu__link'>
            Profile Settings
          </Link>
          <Button
            sFlavor='underline'
            fnHandleClick={fnSignOut}
            className='userProfileMenu__signOut'
          >
            Sign Out
          </Button>
        </div>
      )}
    </div>
  );
};

export default UserProfileMenu;
